module.exports = __webpack_public_path__ + "images/external_images/svg/icons/010-device.svg";